import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyChooseUs = () => {
  const differentiators = [
    {
      icon: "Search",
      title: "Proprietary Assessment Methodology",
      description: "Our comprehensive 47-point assessment process identifies optimization opportunities that others miss, ensuring maximum ROI from your fiber investment.",
      features: [
        "Network performance baseline analysis",
        "Future capacity requirement planning",
        "Risk assessment and mitigation strategies",
        "Cost-benefit optimization modeling"
      ]
    },
    {
      icon: "Settings",
      title: "Minimal-Disruption Installation",
      description: "Advanced installation techniques and careful project planning minimize business interruption while ensuring superior installation quality.",
      features: [
        "After-hours and weekend installation options",
        "Phased implementation for critical systems",
        "Temporary connectivity during transitions",
        "Real-time progress monitoring and updates"
      ]
    },
    {
      icon: "Headphones",
      title: "Comprehensive Post-Installation Support",
      description: "Our relationship doesn't end at installation. We provide ongoing support, monitoring, and optimization to ensure long-term success.",
      features: [
        "24/7 emergency support hotline",
        "Proactive network monitoring services",
        "Annual performance optimization reviews",
        "Training programs for internal IT teams"
      ]
    },
    {
      icon: "Users",
      title: "Strategic Partnership Approach",
      description: "We function as an extension of your IT team, providing strategic guidance and technical expertise for long-term infrastructure planning.",
      features: [
        "Dedicated account management",
        "Technology roadmap consultation",
        "Vendor relationship management",
        "Compliance and documentation support"
      ]
    }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Why Choose Xtreem Fibre Solutions
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our unique approach combines technical expertise with strategic thinking, delivering infrastructure solutions that drive business transformation.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8">
          {differentiators?.map((item, index) => (
            <div key={index} className="bg-white rounded-xl shadow-brand-moderate hover:shadow-brand-strong transition-all duration-300 p-8 group">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-primary/10 rounded-xl group-hover:bg-primary group-hover:text-white transition-all duration-300">
                  <Icon name={item?.icon} size={28} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-text-primary mb-3">
                    {item?.title}
                  </h3>
                  <p className="text-text-secondary mb-6 leading-relaxed">
                    {item?.description}
                  </p>
                  <div className="space-y-3">
                    {item?.features?.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center space-x-3">
                        <Icon name="CheckCircle" size={16} className="text-accent flex-shrink-0" />
                        <span className="text-sm text-text-secondary">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-4 p-6 bg-white rounded-xl shadow-brand-moderate">
            <div className="p-3 bg-accent/10 rounded-lg">
              <Icon name="Award" size={32} className="text-accent" />
            </div>
            <div className="text-left">
              <h4 className="text-lg font-semibold text-text-primary">Industry Recognition</h4>
              <p className="text-text-secondary">Voted "Best Telecommunications Contractor" 3 years running</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;